import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { baseUrl } from "./Components/baseUrl";
import axios from "axios";
import { translation } from "./Components/Translation";
import { runVisitorBootstrap } from "./Components/visitorBootstrap";
const Login = () => {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "fa");
  useEffect(() => {
    document.title = "ویزیت | ورود";
  }, []);
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const loginHandler = (e) => {
    e.preventDefault();
    let data = new FormData();
    data.append("username", userName);
    data.append("password", password);
    let config = {
      method: "POST",
      url: `${baseUrl}/login`,
      data: data,
    };
    axios(config)
      .then(async (response) => {
        localStorage.setItem(
          "user",
          JSON.stringify(response.data.data)
        );
        localStorage.setItem("token", response.data.data.token);
        localStorage.setItem("lang", "fa");
        await runVisitorBootstrap(axios, baseUrl).catch(() => null);
        navigate("/", { replace: true });
      })
      .catch(function () {
        toast.error("نام کاربری یا رمز عبور خود را اشتباه وارد کرده اید", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };
  return (
    <div className="container">
      <form className="login-main">
        <img src="./assets/images/logo.svg" alt="" />
        <input
          type="text"
          name="username"
          placeholder={
            translation.login01[lang]
              ? translation.login01[lang]
              : "نام کاربری"
          }
          id="username"
          onChange={(e) => setUserName(e.target.value)}
        />
        <input
          type="password"
          name="password"
          placeholder={
            translation.login02[lang]
              ? translation.login02[lang]
              : "رمز عبور"
          }
          id="password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <small className="cus-text mt-25">اپلیکیشن مخصوص ویزیتور و تحصیلدار</small>

        <div className="login-demo-card">
          <span className="login-demo-badge">ورود آزمایشی</span>
          <div className="login-demo-creds">
            <div className="login-demo-item">
              <span className="login-demo-label">نام کاربری</span>
              <span className="login-demo-value">demo</span>
            </div>
            <div className="login-demo-divider"></div>
            <div className="login-demo-item">
              <span className="login-demo-label">رمز عبور</span>
              <span className="login-demo-value">123456</span>
            </div>
          </div>
        </div>

        <button
          onClick={loginHandler}
          className="login-btn mt-25"
          type="submit"
          id="login-btn"
        >
          {translation.login[lang] ? translation.login[lang] : "ورود"}
          <svg
            width="9"
            height="15"
            viewBox="0 0 9 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 2L1.80417 6.76285C1.3718 7.15918 1.3718 7.84082 1.80417 8.23715L7 13"
              stroke="white"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>
        </button>
        <a
          target={"_blank"}
          href="https://www.panel.payacom.com/login"
          className="login-btn by-username"
          rel="noreferrer"
        >
          شرکت پخش دارم
          <svg
            width="9"
            height="15"
            viewBox="0 0 9 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 2L1.80417 6.76285C1.3718 7.15918 1.3718 7.84082 1.80417 8.23715L7 13"
              stroke="white"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>
        </a>
      </form>
    </div>
  );
};

export default Login;
